import { api } from './api.config'

import request from '@/utils/request'
export default {
  personalInvoices: {
    // 获取全部信息表
    cardList (data) {
      return request({
        url: api.personalInvoices.cardList,
        method: `post`,
        data
      })
    },
    // 删除异常库信息
    deleteCard (data) {
      return request({
        url: api.personalInvoices.deleteCard,
        method: 'post',
        data
      })
    },
    // 正常库存信息
    getCard (data) {
      return request({
        url: api.personalInvoices.getCard,
        method: 'get',
        data
      })
    },
    // 正常发票详情信息(票夹)
    getInvoiceInfo (data) {
      return request({
        url: api.personalInvoices.getInvoiceInfo,
        method: 'get',
        data
      })
    },
    // 非增发票详情信息(票夹)
    getNonInvoiceInfo (data) {
      return request({
        url: api.personalInvoices.getNonInvoiceInfo,
        method: 'get',
        data
      })
    },
    // 异常发票详情信息(票夹)
    getAbnormalInvoiceInfo (data) {
      return request({
        url: api.personalInvoices.getAbnormalInvoiceInfo,
        method: 'get',
        data
      })
    },
    getStrangeCard (id) {
      return request({
        url: api.personalInvoices.getStrangeCard + id,
        method: 'post'
      })
    },
    // 非增查询
    getNonVat (data, params) {
      return request({
        url: api.personalInvoices.getNonVat,
        method: 'get',
        data,
        params
      })
    }
  }
}
